"use client";

import Link from "next/link";
import { TrendingUp, Sparkles } from "lucide-react";
import { wikiLink } from "@/lib/url";

const POPULAR_SEARCHES = [
  "보톡스",
  "필러",
  "레이저토닝",
  "울쎄라",
  "슈링크",
  "인모드",
  "리쥬란",
  "피코레이저",
];

const CATEGORY_SHORTCUTS = [
  { label: "주름개선", query: "purpose=주름개선", emoji: "✨" },
  { label: "탄력", query: "purpose=탄력", emoji: "💪" },
  { label: "모공관리", query: "purpose=모공관리", emoji: "🔬" },
  { label: "색소개선", query: "purpose=색소개선", emoji: "🌟" },
  { label: "리프팅", query: "purpose=리프팅", emoji: "⬆️" },
  { label: "여드름치료", query: "purpose=여드름치료", emoji: "💊" },
];

export function PopularSection() {
  return (
    <div className="space-y-8">
      <section>
        <div className="mb-3 flex items-center gap-2">
          <TrendingUp className="h-4 w-4 text-violet-500" />
          <h3 className="text-sm font-bold">인기 검색어</h3>
        </div>
        <div className="flex flex-wrap gap-2">
          {POPULAR_SEARCHES.map((term) => (
            <Link
              key={term}
              href={wikiLink(term)}
              className="rounded-full border border-gray-200 px-4 py-2 text-sm font-medium transition-all hover:border-violet-300 hover:bg-violet-50 hover:text-violet-700"
            >
              {term}
            </Link>
          ))}
        </div>
      </section>

      <section>
        <div className="mb-3 flex items-center gap-2">
          <Sparkles className="h-4 w-4 text-violet-500" />
          <h3 className="text-sm font-bold">고민별 탐색</h3>
        </div>
        <div className="grid grid-cols-2 gap-2 sm:grid-cols-3">
          {CATEGORY_SHORTCUTS.map((cat) => (
            <Link
              key={cat.label}
              href={`/wiki/explore?${cat.query}`}
              className="card-hover flex items-center gap-3 rounded-2xl border border-gray-200 bg-white px-4 py-3 transition-all hover:border-violet-200"
            >
              <span className="text-xl">{cat.emoji}</span>
              <span className="text-sm font-semibold">{cat.label}</span>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
